import './landing.css'
import { mountLandingHero } from './landingHero'

const params = new URLSearchParams(window.location.search)
const gameKeys = ['view', 'at', 'mode', 'player', 'journey']

if (gameKeys.some((key) => params.has(key))) {
  window.location.replace(`/play/arenal/${window.location.search}${window.location.hash}`)
}

const heroCanvas = document.querySelector<HTMLCanvasElement>('#hero-canvas')
if (heroCanvas) {
  try {
    mountLandingHero(heroCanvas)
  } catch {
    // CSS stage behind the canvas still reads as a sky if WebGL fails.
  }
}

const LANDING_STORAGE_KEY = 'roam:landing:analytics'
const MAX_EVENTS = 100

function trackLanding(action: string): void {
  const entry = {
    event: 'landing_action',
    action,
    t: new Date().toISOString(),
  }

  try {
    const prior = JSON.parse(localStorage.getItem(LANDING_STORAGE_KEY) ?? '[]') as unknown[]
    const next = [...(Array.isArray(prior) ? prior : []), entry].slice(-MAX_EVENTS)
    localStorage.setItem(LANDING_STORAGE_KEY, JSON.stringify(next))
  } catch {
    // The landing page remains fully functional when storage is unavailable.
  }

  window.dispatchEvent(new CustomEvent('roam:analytics', { detail: entry }))
}

document.querySelectorAll<HTMLElement>('[data-track]').forEach((element) => {
  element.addEventListener('click', () => {
    trackLanding(element.dataset.track ?? 'unknown')
  })
})

const toast = document.querySelector<HTMLElement>('#map-toast')
let toastTimer: number | undefined

document.querySelectorAll<HTMLButtonElement>('.pin.locked').forEach((button) => {
  button.addEventListener('click', () => {
    const world = button.getAttribute('aria-label')?.split(',')[0] ?? 'This world'
    if (!toast) return
    toast.textContent = `${world} is still sealed — Arenal is open`
    toast.classList.add('show')
    window.clearTimeout(toastTimer)
    toastTimer = window.setTimeout(() => toast.classList.remove('show'), 2400)
  })
})

const revealTargets = document.querySelectorAll<HTMLElement>(
  [
    '.section-intro',
    '.atlas-slate',
    '.roam-grid',
    '.discover-beats',
    '.companion-pair',
    '.history-entry',
    '.faq-list',
    '.final-copy',
  ].join(', '),
)

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add('is-visible')
        observer.unobserve(entry.target)
      })
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
  )

  revealTargets.forEach((element) => {
    element.classList.add('reveal')
    observer.observe(element)
  })
}
